const LIVE_SELECTED_CLASS_ID_KEY = 'opus_live_selected_class_id'
const LIVE_SELECTED_CLASS_LABEL_KEY = 'opus_live_selected_class_label'
const LIVE_QUEUE_BY_CLASS_KEY = 'opus_live_queue_by_class'

function isBrowser() {
  return typeof window !== 'undefined' && !!window.sessionStorage
}

function safeReadJson(key, fallbackValue) {
  if (!isBrowser()) return fallbackValue
  try {
    const raw = window.sessionStorage.getItem(key)
    if (!raw) return fallbackValue
    const parsed = JSON.parse(raw)
    return parsed ?? fallbackValue
  } catch (_) {
    return fallbackValue
  }
}

function safeWriteJson(key, value) {
  if (!isBrowser()) return
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch (_) {
    // ignore storage errors
  }
}

function safeReadString(key) {
  if (!isBrowser()) return ''
  try {
    return String(window.sessionStorage.getItem(key) || '').trim()
  } catch (_) {
    return ''
  }
}

function safeWriteString(key, value) {
  if (!isBrowser()) return
  try {
    window.sessionStorage.setItem(key, String(value || '').trim())
  } catch (_) {
    // ignore storage errors
  }
}

function normalizeQueue(items = []) {
  const out = []
  const seen = new Set()
  items.forEach((item, index) => {
    const exerciseId = String(item?.exerciseId || '').trim()
    if (!exerciseId || seen.has(exerciseId)) return
    seen.add(exerciseId)
    out.push({
      exerciseId,
      exerciseTitle: String(item?.exerciseTitle || '').trim() || 'Exercice',
      order: Number.isFinite(item?.order) ? Number(item.order) : index
    })
  })
  return out
    .sort((a, b) => a.order - b.order)
    .map((item, index) => ({ ...item, order: index }))
}

function normalizeQueueByClass(queueByClass = {}) {
  const normalized = {}
  Object.entries(queueByClass || {}).forEach(([classId, queue]) => {
    const safeClassId = String(classId || '').trim()
    if (!safeClassId) return
    normalized[safeClassId] = normalizeQueue(Array.isArray(queue) ? queue : [])
  })
  return normalized
}

export function loadLiveSessionDraft() {
  const selectedClassId = safeReadString(LIVE_SELECTED_CLASS_ID_KEY)
  const selectedClassLabel = safeReadString(LIVE_SELECTED_CLASS_LABEL_KEY)
  const queueByClass = normalizeQueueByClass(safeReadJson(LIVE_QUEUE_BY_CLASS_KEY, {}))
  return { selectedClassId, selectedClassLabel, queueByClass }
}

export function setSelectedLiveSessionClass(classId, classLabel = '') {
  safeWriteString(LIVE_SELECTED_CLASS_ID_KEY, classId || '')
  safeWriteString(LIVE_SELECTED_CLASS_LABEL_KEY, classLabel || '')
}

export function replaceLiveSessionQueueByClass(queueByClass = {}) {
  safeWriteJson(LIVE_QUEUE_BY_CLASS_KEY, normalizeQueueByClass(queueByClass))
}

export function addExerciseToLiveSessionDraft({ classId, exerciseId, exerciseTitle }) {
  const safeClassId = String(classId || '').trim()
  const safeExerciseId = String(exerciseId || '').trim()
  if (!safeClassId || !safeExerciseId) {
    return { added: false, queueLength: 0, duplicate: false }
  }
  const draft = loadLiveSessionDraft()
  const currentQueue = Array.isArray(draft.queueByClass[safeClassId]) ? draft.queueByClass[safeClassId] : []
  if (currentQueue.some((item) => item.exerciseId === safeExerciseId)) {
    return { added: false, queueLength: currentQueue.length, duplicate: true }
  }
  const nextQueue = normalizeQueue([
    ...currentQueue,
    { exerciseId: safeExerciseId, exerciseTitle: String(exerciseTitle || '').trim() || 'Exercice', order: currentQueue.length }
  ])
  const nextQueueByClass = {
    ...draft.queueByClass,
    [safeClassId]: nextQueue
  }
  replaceLiveSessionQueueByClass(nextQueueByClass)
  return { added: true, queueLength: nextQueue.length, duplicate: false }
}
